export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8101.b1a9370b.jpg";